import OrdersList from "./OrdersList";

export default {
    list: OrdersList,
};
